export default "__VITE_ASSET__DiyCly_4__"